import { AppLanguage, IAppConfig } from '@tnq/shared/types';

export const config: IAppConfig = {
  languageOptions: [AppLanguage.Dutch],
};
